// Общая для сопроводителя (карточка обзвона) и звонильщика (рабочее место сделки)
// кнопка «⭳ Подтянуть данные из старого МК»: ищем клиента по телефону в выгрузке
// старого МойКласса (routes/oldmk.js), заполняем ПУСТЫЕ поля анкеты и дописываем
// историю занятий в комментарий лида. Заполненное менеджером не перетираем.
// Одна реализация на обе карточки (Антон 15.09: «повтори, нового не плоди»).
import api from '../api'

export const PULL_OLDMK_LABEL = '⭳ Подтянуть данные из старого МК'
export const PULL_OLDMK_TITLE = 'Найти клиента в выгрузке старого МойКласса и заполнить поля'

/**
 * @param {object} p
 * @param {number} p.leadId       id лида
 * @param {string} p.phone        телефон для поиска
 * @param {object} p.form         текущие значения анкеты (ключи как в /api/survey)
 * @param {function} p.applyFields async (patch) => сохранить patch в анкету
 * @returns {{found:boolean, msg:string, comment:string|null}}
 */
export async function pullOldMk({ leadId, phone, form, applyFields }) {
  const r = await api.get('/api/oldmk/lookup', { params: { phone } })
  if (!r.data || !r.data.found) return { found: false, msg: 'В старой базе не найден', comment: null }
  const f = r.data.fields || {}
  const patch = {}
  Object.keys(f).forEach(k => {
    if (f[k] && !String((form || {})[k] || '').trim()) patch[k] = f[k]
  })
  if (Object.keys(patch).length) await applyFields(patch)
  if (r.data.comment) {
    await api.post('/api/deals/comment', { leadId, comment: r.data.comment }).catch(() => {})
  }
  return {
    found: true,
    msg: 'Подтянуто: ' + Object.keys(patch).length + ' полей' + (r.data.comment ? ' + история' : ''),
    comment: r.data.comment || null,
  }
}
